
import { Component, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { generalService } from '../../services/general.service';
// import { Personal } from '../models/personal';
// import {Familiar} from '../models/familiar';
import { MatPaginator,MatDialog, MatSort } from '@angular/material';
import { DataService } from '../../utils/data.service';
import { BitacoraAddEditComponent } from './agregar-editar/bitacora-addedit.component';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
@Component({
  selector: 'my-bitacora',
  styleUrls: [],
  templateUrl: 'bitacora.component.html',
  providers: [generalService]
})


export class BitacoraComponent implements OnInit {
displayedColumns = ['acciones', 'CREATION_DATE', 'TYPE_DESC' , 'COMMENTS'];
dataSource: DataSourceGrid | null;
public datosBitacora: Array<any>;
person_id: string;

 @ViewChild(MatPaginator) paginator: MatPaginator;
 @ViewChild(MatSort) sort: MatSort;

   constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private _generalService: generalService,
    public dataService: DataService,
    public dialog: MatDialog
    ) {
    this.person_id = (this.route.snapshot.paramMap.get('id'));
    this.datosBitacora = new Array();
  }

  ngOnInit() {
    this.getBitacora(this.person_id);
  }

  getBitacora(id: any) {
    this._generalService.metodoCall(`bitacora/consultarBitacoras/${id}`).subscribe(
      (result) => {
        this.datosBitacora = JSON.parse(result);
        this.dataSource = new DataSourceGrid(this.datosBitacora, this.paginator, this.sort);
        if (this.datosBitacora.length <= 0) {
            $('#tableBitacora .mat-row').remove('.mat-row');
          }
      },
      (error) => {
        let errorMsj =  error as any;
        console.log(errorMsj);
      }
    );
  }

  agregar() {
    this.dataService.isUpdate = false;
    const dialogRef = this.dialog.open(BitacoraAddEditComponent, {disableClose: true});
    this.dataService.idPersonal = this.person_id;
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((result) => {
        this.getBitacora(this.person_id);
    });
  }

  editar(idBitacora) {
    this.dataService.id = idBitacora;
    this.dataService.isUpdate = true;
    this.dataService.idPersonal = this.person_id;
    const dialogRef = this.dialog.open(BitacoraAddEditComponent, {disableClose: true});
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((result) => {
      this.getBitacora(this.person_id);
    });
  }

  eliminarConfirm(data: any) {
    const eliminarHttp = new EventEmitter<any>();
    eliminarHttp.subscribe(
      (response: any) => {
        this._generalService.toastCall('El registro se eliminó exitosamente!');
        this.ngOnInit();

      }
    );
    const bitacora: any = new Object();
    bitacora.TRANSACTION_ID = data.TRANSACTION_ID;
    this._generalService.modal(eliminarHttp, 'confirm', '¿Desea eliminar el registro ' + data.TYPE_DESC + '?' , 'bitacora/eliminarBitacora/', bitacora);
  }
}



// WEBPACK FOOTER //
// ./src/app/personal/bitacora/bitacora.component.ts